import * as React from "react"
import { Col, Container, Row, Visible } from "react-grid-system"
import styled from "styled-components"
import { theme } from "../../components/theme"
import { SatcubeLogo } from "../../images/SatcubeLogo"
import { MediaQuery } from "../../utils/design-helpers"
import { HorizontalSpacer, Spacer } from "../atoms/spacers"
import { YoutubeIcon } from "../atoms/icons/SocialMediaIcons/YoutubeIcon"
import { LinkedInIcon } from "../atoms/icons/SocialMediaIcons/LinkedInIcon"
import { Link } from "react-router-dom"
import BodyMedium from "../atoms/typography/BodyMedium"
import TextButton from "../atoms/buttons/TextButton"
import H4 from "../atoms/typography/H4"
import { ADDRESS_GOTHENBURG, ADDRESS_KARLSTAD, ADDRESS_USA } from "../../utils/addresses"

const HeaderContainer = styled.div`
  width: 100vw;
  background-color: ${(props) => props.theme.colors.greyDarker};
  padding: 5rem;

  ${MediaQuery.XS} {
    padding: 2rem;
  }
`

const IconRowContainer = styled.div`
  display: flex;
  align-items: center;
`

const LinkWithoutDecoration = styled.a`
  color: ${(props) => props.theme.colors.greyDark};
  text-decoration: none;
`

const Footer: React.FunctionComponent = () => {
  return (
    <HeaderContainer>
      <Container>
        <Row>
          <Col lg={2} />
          <Col lg={3}>
            <H4 color={theme.colors.white}>Satcube</H4>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="/about">
              <TextButton color={theme.colors.white} title="About us" />
            </LinkWithoutDecoration>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="/contact">
              <TextButton color={theme.colors.white} title="Contact us" />
            </LinkWithoutDecoration>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="https://careers.satcube.com" target="_blank">
              <TextButton color={theme.colors.white} title="Careers" />
            </LinkWithoutDecoration>
            <HorizontalSpacer spacing={0.5} />
            <Link to="/privacy_policy" target="_blank" rel="noopener noreferrer">
              <TextButton color={theme.colors.white} title="Privacy policy" />
            </Link>
          </Col>
          <Col lg={3}>
            <H4 color={theme.colors.white}>Products</H4>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="/products/ku">
              <TextButton color={theme.colors.white} title="Satcube KU" />
            </LinkWithoutDecoration>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="/products/secure">
              <TextButton color={theme.colors.white} title="Satcube Secure" />
            </LinkWithoutDecoration>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="/products/motion">
              <TextButton color={theme.colors.white} title="Satcube Motion" />
            </LinkWithoutDecoration>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="/store#accessories">
              <TextButton color={theme.colors.white} title="Accessories" />
            </LinkWithoutDecoration>
            <HorizontalSpacer spacing={2} />
            <LinkWithoutDecoration href="/store">
              <H4 color={theme.colors.white}>Store & Rental</H4>
            </LinkWithoutDecoration>
          </Col>
          <Col lg={3}>
            <H4 color={theme.colors.white}>Resources</H4>
            <HorizontalSpacer spacing={0.5} />
            <Link to="/news">
              <TextButton color={theme.colors.white} title="News" />
            </Link>
            <HorizontalSpacer spacing={0.5} />
            <LinkWithoutDecoration href="https://support.satcube.com" target="_blank">
              <TextButton color={theme.colors.white} title="Support" />
            </LinkWithoutDecoration>
          </Col>
        </Row>

        <HorizontalSpacer spacing={6} />

        <Row>
          <Col lg={2} />
          <Col
            lg={3}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <BodyMedium color={theme.colors.white}>Head office:</BodyMedium>
              <LinkWithoutDecoration target="_blank" href={ADDRESS_GOTHENBURG.url}>
                <BodyMedium color={theme.colors.white}>{ADDRESS_GOTHENBURG.street}</BodyMedium>

                <BodyMedium color={theme.colors.white}>
                  {ADDRESS_GOTHENBURG.code} {ADDRESS_GOTHENBURG.city}, {ADDRESS_GOTHENBURG.country}
                </BodyMedium>
              </LinkWithoutDecoration>
            </div>
            <HorizontalSpacer spacing={1} />
            <div>
              <BodyMedium color={theme.colors.white}>Production:</BodyMedium>
              <LinkWithoutDecoration href={ADDRESS_KARLSTAD.url} target="_blank">
                <BodyMedium color={theme.colors.white}>{ADDRESS_KARLSTAD.street}</BodyMedium>

                <BodyMedium color={theme.colors.white}>
                  {ADDRESS_KARLSTAD.code} {ADDRESS_KARLSTAD.city}, {ADDRESS_KARLSTAD.country}
                </BodyMedium>
              </LinkWithoutDecoration>
            </div>
          </Col>

          <Col
            lg={3}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Visible xs sm>
              <HorizontalSpacer spacing={2} />
            </Visible>
            <div>
              <BodyMedium color={theme.colors.white}>USA office:</BodyMedium>
              <LinkWithoutDecoration href={ADDRESS_USA.url} target="_blank">
                <BodyMedium color={theme.colors.white}>Satcube Inc.</BodyMedium>
                <BodyMedium color={theme.colors.white}>{ADDRESS_USA.street}</BodyMedium>
                <BodyMedium color={theme.colors.white}>
                  {ADDRESS_USA.city} {ADDRESS_USA.code}
                </BodyMedium>
                <BodyMedium color={theme.colors.white}>{ADDRESS_USA.country}</BodyMedium>
              </LinkWithoutDecoration>
            </div>
            <HorizontalSpacer spacing={1} />
            <div>
              <Visible xs>
                <HorizontalSpacer spacing={2} />
              </Visible>
              <SatcubeLogo />
            </div>
          </Col>

          <Col
            lg={3}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Visible xs sm>
              <HorizontalSpacer spacing={2} />
            </Visible>
            <a href="https://www.youtube.com/@satcube" target="_blank">
              <IconRowContainer>
                <YoutubeIcon /> <Spacer spacing={1} />
                <BodyMedium color={theme.colors.white}>Satcube</BodyMedium>
              </IconRowContainer>
            </a>
            <Visible xs sm>
              <HorizontalSpacer spacing={2} />
            </Visible>
            <a href="https://www.linkedin.com/company/satcube-ab/" target="_blank">
              <IconRowContainer>
                <LinkedInIcon /> <Spacer spacing={1} />
                <BodyMedium color={theme.colors.white}>Satcube</BodyMedium>
              </IconRowContainer>
            </a>
          </Col>
        </Row>

        <HorizontalSpacer spacing={4} />
      </Container>
    </HeaderContainer>
  )
}

export default Footer
